// extracted by mini-css-extract-plugin
export default {"shadowed":"Navbar_shadowed__aijae","active":"Navbar_active__3ybcC","link":"Navbar_link__-oXfi"};